/* NOSKOO — cart drawer: ajax add to cart, quantity changes, open/close. No dependencies. */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-nk-drawer]');
  if (!drawer) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCart = document.body.classList.contains('template-cart');
  var lastFocus = null;

  var link = document.querySelector('.nk-header__tools a[href*="/cart"]');
  if (link && !onCart) link.setAttribute('data-nkd-open', '');

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = drawer.querySelector('.nkd__panel');
    if (panel) panel.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      if (n > prev) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }

  function refresh() {
    var id = drawer.getAttribute('data-section-id');
    return Promise.all([
      fetch(root + '?sections=' + encodeURIComponent(id)).then(function (r) { return r.json(); }),
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0][id];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.nkd__panel');
        var panel = drawer.querySelector('.nkd__panel');
        if (next && panel) panel.innerHTML = next.innerHTML;
      }
      setCount(res[1].item_count);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nkd-open]')) { e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-nkd-close]')) { close(); return; }
    var q = e.target.closest('[data-nkd-qty]');
    if (q) {
      e.preventDefault();
      var line = parseInt(q.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(q.getAttribute('data-nkd-qty'), 10));
      var row = q.closest('.nkd__line');
      if (row) row.style.opacity = '.5';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(refresh)
        .catch(function () { if (row) row.style.opacity = ''; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('.nk-form-msg');
    if (!msg) { msg = document.createElement('p'); msg.className = 'nk-form-msg'; msg.setAttribute('role', 'alert'); msg.hidden = true; form.appendChild(msg); }
    msg.hidden = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { msg.textContent = res.d.description || 'Das hat leider nicht geklappt.'; msg.hidden = false; return; }
        return refresh().then(open);
      })
      .catch(function () { msg.textContent = 'Das hat leider nicht geklappt. Bitte versuche es erneut.'; msg.hidden = false; })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
})();
